export default __webpack_public_path__ + "f4573d4d02ad19e6463f93d16eb40583.svg";